import { render, staticRenderFns } from "./calc-quiz.vue?vue&type=template&id=0da690c2&scoped=true"
import script from "./calc-quiz.vue?vue&type=script&lang=js"
export * from "./calc-quiz.vue?vue&type=script&lang=js"
import style0 from "./calc-quiz.vue?vue&type=style&index=0&id=0da690c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da690c2",
  null
  
)

export default component.exports